import { Box } from '@mui/material';
import React from 'react';
import { UseKeycloakService } from '@europrocurement/l2d-keycloak';
import {
    ComptaDashboard,
    dossiersBasePath,
    FormalistDashboard,
    FormalistManagerDashboard,
    InternDashboard,
} from '@europrocurement/l2d-modules';
import { useNavigate } from 'react-router';
import RelevesNonClotures from '../Accueil/WidgetsFrame/PortailAchatsWidgets/Widgets/RelevesNonClotures';
import MesFacturesATraiter from '../Accueil/WidgetsFrame/PortailAchatsWidgets/Widgets/MesFacturesATraiter';
import FacturesInternesNonAttribuees from '../Accueil/WidgetsFrame/PortailAchatsWidgets/Widgets/FacturesInternesNonAttribuees';
import FacturesASynchroniser from '../Accueil/WidgetsFrame/PortailAchatsWidgets/Widgets/FacturesASynchroniser';
import FacturesAvecErreursTechniques from '../Accueil/WidgetsFrame/PortailAchatsWidgets/Widgets/FacturesAvecErreursTechniques';
import FacturesEnERDO5 from '../Accueil/WidgetsFrame/PortailAchatsWidgets/Widgets/FacturesEnERDO5';
import FacturesATraiterManuellement from '../Accueil/WidgetsFrame/PortailAchatsWidgets/Widgets/FacturesATraiterManuellement';
import FacturesEnPause from '../Accueil/WidgetsFrame/PortailAchatsWidgets/Widgets/FacturesEnPause';

const Dashboard = function () {
    const keycloakService = UseKeycloakService();

    const isIntern = keycloakService.checkRole('realm:interne');
    const isCompta = keycloakService.checkRole('realm:compta');
    const isFormalist = keycloakService.checkRole('realm:formaliste');
    const isFormalistManager = keycloakService.checkRole('realm:responsable formaliste');
    const { idUserGie } = keycloakService.getTokenParsed();
    const navigate = useNavigate();

    return (
        <Box>
            {isIntern && !isFormalist && !isCompta && (
                <InternDashboard
                    title="Dashboard"
                    userId={parseInt(idUserGie, 10)}
                />
            )}

            {isCompta && (
                <ComptaDashboard
                    title="Dashboard comptabilité"
                    childrens={[
                        { key: 'list-widget-facture-en-pause', component: <FacturesEnPause /> },
                        { key: 'list-widget-releve-non-clotur', component: <RelevesNonClotures /> },
                        {
                            key: 'list-widget-mes-facture-a-traiter',
                            component: <MesFacturesATraiter />,
                        },
                        {
                            key: 'list-widget-facture-non-attibuees',
                            component: <FacturesInternesNonAttribuees />,
                        },
                        {
                            key: 'list-widget-facture-a-synchro',
                            component: <FacturesASynchroniser />,
                        },
                        {
                            key: 'list-widget-facture-erreur-technique',
                            component: <FacturesAvecErreursTechniques />,
                        },
                        { key: 'list-widget-facture-er-dos5', component: <FacturesEnERDO5 /> },
                        {
                            key: 'list-widget-facture-traiter-manuellement',
                            component: <FacturesATraiterManuellement />,
                        },
                    ]}
                />
            )}

            {isFormalist && (
                <FormalistDashboard
                    formalistIds={[parseInt(idUserGie, 10)]}
                    listeDossiersPath={dossiersBasePath}
                    navigate={navigate}
                    title="Dashboard formaliste"
                />
            )}

            {isFormalistManager && (
                <FormalistManagerDashboard
                    formalistId={parseInt(idUserGie, 10)}
                    listeDossiersPath={dossiersBasePath}
                    navigate={navigate}
                    title="Dashboard responsable formaliste"
                />
            )}
        </Box>
    );
};

export default Dashboard;
